import Vue from 'vue';
import cityList from '../tools/cityList';
import axios from 'axios';


const api = {
  cityList: '/api/weather/admin/cityList',
  liveData: '/api/weather/web/live',
  forecastData: '/api/weather/web/forecast',
}

// 如果是本地环境,请求7001端口的
if(location.host === "localhost:8080") {
  for(let key in api) {
    api[key] = 'http://localhost:7001' + api[key]
  }
}

const TEN_MIN =  1000 * 60 * 10

export default class Weather {
  constructor() {
    this.count = 0
    this.storeTime = new Date();
    this.data = [];
    this.fetchLiveData()

    setInterval(() => {
      this.fetchLiveData();
    }, TEN_MIN);
  }

  /**获取实时的天气数据 */
  async fetchLiveData(date) {
    const cityList = await this.fetchCityList();
    const cityCenterMap = this.getCityCenterMap(cityList);
    const params = { date: date ? date : '' };
    const loading = Vue.prototype.$loading({
      lock: true,
      text: "加载中",
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })

    return axios.get(api.liveData, { params }).then(res => {
      loading.close();
      if (res.status === 200) {
        // 计数count,如果第一次调用,则是初始化化的时候,不进行提示
        if (this.count) {
          res.data.length 
            ? ''
            : Vue.prototype.$message.error('暂无数据')
        }
        this.count++;

        this.data = res.data.map(item => {
          item.center = cityCenterMap[item.adcode];
          delete item.__v;
          delete item._id;
          return item;
        });

        if (this.data.length) {
          const time = this.data[0].time;
          this.storeTime = time;
        }
      } else {
        Vue.prototype.$message.error('更新数据失败');
      }
    }).catch(err => {
      loading.close();
      Vue.prototype.$message.error('网络错误');
    })
  }

  /**获取城市列表数据 */
  async fetchCityList() {
    return axios.get(api.cityList).then(res => {
      if (res.status === 200) {
        return res.data.data;
      } else {
        Vue.prototype.$message.error('获取城市数据失败');
      }
    })
  }

  /**获取城市和中心点的数据映射关系 */
  getCityCenterMap(cityList) {
    const cityCenterMap = {};

    cityList.forEach(item => {
      cityCenterMap[item.adcode] = item.center;
    })

    return cityCenterMap;
  }

  static fetchForecastData(time, adcode) {
    const params = {
      date: time,
      adcode: adcode,
    }
    
    return axios.get(api.forecastData, {params}).then(res => {
      if (res.status === 200) {
        return res.data;
      } else {
        return [];
      }
    })
  }
}